import * as STD from '@emersya/mpa-std';

/**
 * Abstract class designed to create common interface for extending components instances.
 * Allowing to have customs component logics / behaviors on generic component.
 * To not pollute instance with non standard properties and to not confuse typescript types system,
 * plugin system implemented by the "servant" design pattern[https://en.wikipedia.org/wiki/Servant_(design_pattern)]
 */
abstract class Plugin<TComponent extends Component<any, any>> {
	abstract id : string;

	/**
	 * Attach plugin to the component
	 */
	abstract attach(component : TComponent) : void;

	/**
	 * Detach plugin to the component
	 */
	abstract detach(component : TComponent) : void;
};

namespace Plugin {
	export abstract class PluginWithData<
		TComponent extends Component<any, any>,
		TComponentData extends any
	> extends Plugin<TComponent> {
		private dataByComponent : WeakMap<TComponent, TComponentData> = new WeakMap;

		protected abstract generateData(component : TComponent) : TComponentData;

		protected getData(component : TComponent) {
			const data = this.dataByComponent.get(component);
			if (!data) {
				throw STD.errors.user('Unregistered component!', {
					component
				});
			}
			return (data);
		};

		attach(component : TComponent) {
			this.dataByComponent.set(component, this.generateData(component));
		};

		detach(component : TComponent) {
			this.dataByComponent.delete(component);
		};
	};
	export type TPlugin<
		TComponent extends Component<any, any>,
		TInterface extends object
	> = Plugin<TComponent> & TInterface;
}
export default Plugin;

import Component from './Component';
